/* eslint-disable */
import React, { useState, useContext, useEffect, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import CmsContext from 'context/CmsContext';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { get, getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { withStyles } from '@material-ui/core/styles';
import { PAGE_DIMENSIONS } from 'lib/tiny-mce';
import { parseString } from 'utils/parseString';
import DOMPurify from 'dompurify';
import CreateModal from './components/CreateModal';
import UpdateModal from './components/UpdateModal';
import * as actions from './actions';
import * as c from './constants';
import ViewOrFees from './components/ViewOrFees';
import './PaymentOfficialReceiptContainer.css';

const styles = () => ({
  dialogPaper: {
    width: '100%',
    maxWidth: '400px',
  },
});

const Log = ({
  getListCms,
  itemHtml,
  isLoading,
  finalizeOfficialReceipt,
  removeOfficialReceipt,
  getOfficialReceipts,
  officialReceiptList,
  transactionId,
  findPaymentById,
  history,
}) => {
  const handleBack = (e) => {
    e.preventDefault();
    const restoreTransactionId =
      transactionId || localStorage.getItem('transId') || '';
    history.push({
      pathname: '/payments/inquiry',
      state: { restoreTransactionId },
    });
  };
  const [totalAmount, setTotalAmount] = useState(
    localStorage.getItem('total_amount')
  );
  const [amountWithoutOr, setAmountWithoutOr] = useState(
    localStorage.getItem('amount_without_or')
  );
  const [amountWithOr, setAmountWithOr] = useState(
    localStorage.getItem('amount_with_or')
  );

  const cmsContext = useContext(CmsContext);
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');
  const item = JSON.parse(localStorage.getItem('itemData'));
  const bplsBusiness = _.get(item, 'included.bplsBusiness.attributes', {});
  const bplsPermitApplication = _.get(
    item,
    'included.bplsApplication.attributes',
    {}
  );
  const transaction = _.get(item, 'attributes', {});
  const moduleType = _.get(transaction, 'module_type', '');
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  const TYPE = 'OFFICIAL_RECEIPT';
  const PAPER_TYPE = 'BUSINESS_PERMIT_PAPER_SETUP';

  useEffect(() => {
    getListCms({ type: TYPE });
  }, []);

  const parsedPermitList = JSON.parse(
    _.get(itemHtml, 'attributes.body') || '[]'
  );
  const permitList = Array.isArray(parsedPermitList) ? parsedPermitList : [];
  const defaultIndex = permitList.findIndex((permit) => !!permit.selected);

  const contentData = _.get(permitList[defaultIndex], 'body') || '';

  const paperSetup = useMemo(() => {
    if (!itemHtml) return {};
    const parsedItem = parseString(itemHtml);
    const attrib = _.get(parsedItem, 'attributes', {});
    const body = _.get(attrib, 'body', '[]');
    const parsedBody = parseString(body);
    if (!_.isArray(parsedBody)) return {};
    const selectedPermit = parsedBody.find((b) => b?.selected);
    return _.get(selectedPermit, 'paper_setup', {});
  }, [itemHtml]);

  const generatePrintStyles = () => {
    const {
      bottom = '0',
      left = '0',
      paper_margin = '0',
      paper_orientation = 'portrait',
      paper_size = 'letter',
      right = '0',
      top = '0',
    } = paperSetup || {};

    const pageDimensions = PAGE_DIMENSIONS[paper_orientation][paper_size];

    return `
      <style>
        @page { 
        size: ${pageDimensions}; 
        margin: ${top}${paper_margin} ${right}${paper_margin} ${bottom}${paper_margin} ${left}${paper_margin}; 
        }
      </style>
    `;
  };

  useEffect(() => {
    getOfficialReceipts({});
  }, [module]);

  const [triggerEffect, setTriggerEffect] = useState(false);

  useEffect(() => {
    findPaymentById(transactionId, (res) => {
      setAmountWithOr(_.get(res, 'res.data.attributes.amount_with_or'));
      setAmountWithoutOr(_.get(res, 'res.data.attributes.amount_without_or'));
      setTotalAmount(_.get(res, 'res.data.attributes.amount'));
    });
  }, [triggerEffect]);

  const handleTriggerEffect = () => {
    setTriggerEffect((prev) => !prev);
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal triggerParentEffect={handleTriggerEffect} moduleType={moduleType} />,
      title: 'Add Official Receipt',
      modalSize: 'modal-md',
      hideHeader: false,
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          item={data}
          id={data.id}
          triggerParentEffect={handleTriggerEffect}
          moduleType={moduleType}
        />
      ),
      title: 'Update Official Receipt',
      modalSize: 'modal-md',
      hideHeader: false,
    });
  };

  const handleViewOrFees = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewOrFees fees={data.fees} />,
      title: 'View Official Receipt Fees',
      modalSize: 'modal-md',
      hideHeader: false,
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove?',
      () => {
        removeOfficialReceipt(data.id, () => {
          getOfficialReceipts();
          setTriggerEffect((prev) => !prev);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleFinalize = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to finalize?',
      () => {
        finalizeOfficialReceipt(data.id, {}, () => {
          getOfficialReceipts();
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const convertToWords = (amount) => {
    // Arrays for ones, tens, and the thousands
    const ones = [
      '',
      'One',
      'Two',
      'Three',
      'Four',
      'Five',
      'Six',
      'Seven',
      'Eight',
      'Nine',
      'Ten',
      'Eleven',
      'Twelve',
      'Thirteen',
      'Fourteen',
      'Fifteen',
      'Sixteen',
      'Seventeen',
      'Eighteen',
      'Nineteen',
    ];
    const tens = [
      '',
      '',
      'Twenty',
      'Thirty',
      'Forty',
      'Fifty',
      'Sixty',
      'Seventy',
      'Eighty',
      'Ninety',
    ];
    const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion']; // Extend for larger numbers

    // Function to convert numbers less than 1000 into words
    const convertHundreds = (num) => {
      let word = '';
      if (num >= 100) {
        word += ones[Math.floor(num / 100)] + ' Hundred ';
        num %= 100;
      }
      if (num >= 20) {
        word += tens[Math.floor(num / 10)] + ' ';
        num %= 10;
      }
      if (num > 0) {
        word += ones[num] + ' ';
      }
      return word.trim();
    };

    // Handle the case when amount is zero
    if (amount === 0) return 'Zero Pesos Only';

    // Remove commas and handle float to integer conversion
    let wholePart = Math.floor(amount); // Get the whole part (before decimal)
    let fractionalPart = Math.round((amount - wholePart) * 100); // Get the fractional part (after decimal)

    let result = '';
    let i = 0;

    // Handle numbers larger than 999 using the thousands array
    while (wholePart > 0) {
      let part = wholePart % 1000;
      if (part > 0) {
        result = convertHundreds(part) + ' ' + thousands[i] + ' ' + result;
      }
      wholePart = Math.floor(wholePart / 1000);
      i++;
    }

    result = result.trim() + ' Pesos';

    // Handle the fractional part (centavos)
    if (fractionalPart > 0) {
      result += ` and ${convertHundreds(fractionalPart)} Centavos`;
    }

    result += ' Only';

    return result.trim();
  };

  function imagesLoaded(printWindow, callback) {
    const images = printWindow.document.images;
    let loadedCount = 0;

    if (images.length === 0) {
      callback();
      return;
    }

    for (let i = 0; i < images.length; i++) {
      if (images[i].complete) {
        loadedCount++;
        if (loadedCount === images.length) {
          callback();
        }
      } else {
        images[i].addEventListener('load', () => {
          loadedCount++;
          if (loadedCount === images.length) {
            callback();
          }
        });
        images[i].addEventListener('error', () => {
          loadedCount++;
          if (loadedCount === images.length) {
            callback();
          }
        });
      }
    }
  }

  const handleViewOr = (data) => (e) => {
    e.preventDefault();
    const fees = _.get(data, 'fees', []);

    const generateTable = (fees) => {
      let tableHtml = `<table style="border-collapse: collapse; width: 100.337%; height: 102px; border-width: 1px; border-style: none;" border="1">
        <colgroup>
          <col style="width: 100.4042%;">
          <col style="width: 25.6093%;">
        </colgroup>
        <tbody>`;

      fees.forEach((item) => {
        if (_.get(item, 'attributes.total_human', '') !== '0.00') {
          tableHtml += `
            <tr style="height: 20.4px;">
              <td style="text-align: left; border-style: none;"><span style="font-size: 9pt;">${_.get(
                item,
                'name',
                ''
              )}</span></td>
              <td style="text-align: left; border-style: none;"><span style="font-size: 9pt;">${_.get(
                item,
                'amount',
                ''
              )}</span></td>
            </tr>`;
        }
      });

      // Close table tags
      tableHtml += `
        </tbody>
      </table>`;

      return tableHtml;
    };

    const amountString = _.get(data, 'amount', 0);
    const cleanedAmount = parseFloat(amountString.replace(/,/g, ''));
    const amountInWords = convertToWords(cleanedAmount);

    const combinedData = {
      ...bplsBusiness,
      ...transaction,
      ...bplsPermitApplication,
      ...{
        or_date_day: '',
        or_date_month: '',
        or_date_year: '',
        or_days_of_week: '',
        issuance_date_day: '',
        issuance_date_month: '',
        issuance_date_year: '',
        issuance_days_of_week: '',
        validity_date: '',
        issuance_date: '',
        amount_in_words: '',
        fees: [],
        designation: '',
        signatory_1_name: '',
        signatory_1_designation: '',
        signatory_1_signature: '',
        signatory_2_name: '',
        signatory_2_designation: '',
        signatory_2_signature: '',
        signatory_3_name: '',
        signatory_3_designation: '',
        signatory_3_signature: '',
        total: amountString,
        registration_number:
        _.get(bplsBusiness, 'dti_no') ||
        _.get(bplsBusiness, 'sec_no') ||
        _.get(bplsBusiness, 'cda_no') ||
        '',
      },
    };

    let htmlString = contentData;

    // 1. Remove any borders from the `style` attributes of tables and cells (td, th)
    htmlString = htmlString.replace(
      /style="([^"]*?)border[^"]*?"/g,
      (match) => {
        // Ensure `border:none;` and `border-style:hidden;` is applied to all `style` attributes containing borders
        return match
          .replace(/border[^:]*?:[^;]*;/g, 'border:none;')
          .replace(/border-style[^:]*?:[^;]*;/g, 'border-style:hidden;');
      }
    );

    // 2. Set border to `none` for explicit `border` attributes in tables, td, th, tr
    htmlString = htmlString.replace(/border="[^"]*"/g, 'border-style="none"');

    // 3. Hide all images by setting display:none
    // htmlString = htmlString.replace(
    //   /<img[^>]*>/g,
    //   '<img style="visibility:hidden" />'
    // );

    // 4. Apply `border:none;` and `border-style:hidden;` to all table, td, th, and tr elements
    htmlString = htmlString.replace(/<table[^>]*>/g, (match) => {
      return match.replace(/style="([^"]*?)"/g, (style) => {
        return style
          ? style
              .replace(/border[^:]*?:[^;]*;/g, 'border:none;')
              .replace(/border-style[^:]*?:[^;]*;/g, 'border-style:hidden;')
          : 'style="border:none; border-style:hidden;"';
      });
    });

    htmlString = htmlString.replace(/<td[^>]*>/g, (match) => {
      return match.replace(/style="([^"]*?)"/g, (style) => {
        return style
          ? style
              .replace(/border[^:]*?:[^;]*;/g, 'border:none;')
              .replace(/border-style[^:]*?:[^;]*;/g, 'border-style:hidden;')
          : 'style="border:none; border-style:hidden;"';
      });
    });

    htmlString = htmlString.replace(/<th[^>]*>/g, (match) => {
      return match.replace(/style="([^"]*?)"/g, (style) => {
        return style
          ? style
              .replace(/border[^:]*?:[^;]*;/g, 'border:none;')
              .replace(/border-style[^:]*?:[^;]*;/g, 'border-style:hidden;')
          : 'style="border:none; border-style:hidden;"';
      });
    });

    // 5. Set `border-collapse: collapse;` to `border-collapse: separate;` to ensure borders do not appear
    htmlString = htmlString.replace(
      /style="([^"]*?)border-collapse:collapse;?([^"]*?)"/g,
      'style="border-collapse: separate;"'
    );
    htmlString = htmlString
      .replace(/<strong[^>]*>/g, '<strong style="visibility:hidden">')
      .replace(/<\/strong>/g, '</strong>');

    htmlString = htmlString.replace(/\[amount_in_words\]/g, amountInWords);

    const values = JSON.parse(
      JSON.stringify(combinedData, (key, value) =>
        value === null ? '' : value
      )
    );

    htmlString = htmlString.replace(
      /\[no_of_employees_residing_area\]/g,
      '[no_of_employees_residing_manila]'
    );
    htmlString = htmlString.replace(/\[issuance_date\]/g, '[or_generated_at]');
    htmlString = htmlString.replace(/\[or_date\]/g, '[transaction_date]');
    htmlString = htmlString.replace(/\[owner_address\]/g, '[address]');
    htmlString = htmlString.replace(
      /\[business_address\]/g,
      '[display_address]'
    );
    htmlString = htmlString.replace(/\[area_formatted\]/g, '[area_human]');
    htmlString = htmlString.replace(
      /\[capital_amount_formatted\]/g,
      '[capital_amount_human]'
    );
    htmlString = htmlString.replace(
      /\[monthly_rental_formatted\]/g,
      '[monthly_rental_human]'
    );
    htmlString = htmlString.replace(
      /\[tax_credit_formatted\]/g,
      '[tax_credit_human]'
    );

    htmlString = htmlString.replace(/\[or_no\]/g, '[refno]');

    htmlString = htmlString.replace(
      /\[business_status\]/g,
      '[transaction_type]'
    );

    htmlString = htmlString.replace(/\[owners_display_name\]/g, '[name]');

    htmlString = htmlString.replace(/\[email_address\]/g, '[email]');
    htmlString = htmlString.replace(
      /\[floor_area\]/g,
      '[floor_area_human]'
    );

    const replacePlaceholders = (html, values) => {
      let updatedHtml = html;

      for (const key in values) {
        if (Object.hasOwnProperty.call(values, key)) {
          const tag = `[${key}]`;
          let replacementValue = values[key];

          if (key === 'refno') {
            replacementValue = _.get(data, 'number', '');
          }

          if (key === 'or_date_day') {
            replacementValue = moment(_.get(data, 'date', '')).format('DD');
          }

          if (key === 'or_date_month') {
            replacementValue = moment(_.get(data, 'date', '')).format('MMMM');
          }

          if (key === 'or_date_year') {
            replacementValue = moment(_.get(data, 'date', '')).format('YYYY');
          }

          if (key === 'or_days_of_week') {
            replacementValue = moment(_.get(data, 'date', '')).format('dddd');
          }

          if (key === 'transaction_date') {
            replacementValue = moment(_.get(data, 'date', '')).format(
              'MM/DD/YYYY'
            );
          }

          if (key === 'total') {
            replacementValue = amountString;
          }

          if (key === 'issuance_date_day') {
            replacementValue = moment(combinedData.or_generated_at).format(
              'DD'
            );
          }

          if (key === 'issuance_date_month') {
            replacementValue = moment(combinedData.or_generated_at).format(
              'MMMM'
            );
          }

          if (key === 'issuance_date_year') {
            replacementValue = moment(combinedData.or_generated_at).format(
              'YYYY'
            );
          }

          if (key === 'issuance_days_of_week') {
            replacementValue = moment(combinedData.or_generated_at).format(
              'dddd'
            );
          }

          if (key === 'validity_date') {
            replacementValue = moment().endOf('year').format('DD MMM YYYY');
          }

          if (key === 'qr_url') {
            replacementValue = `<p><strong><span style="font-size: 10pt;"><img style="display: block; margin-left: auto; margin-right: auto;" src="${values[key]}" alt="" width="111" height="111"></span></strong></p>`;
          }

          if (key === 'fees') {
            replacementValue = generateTable(fees);
          }

          if (key === 'activities') {
            replacementValue = generateActivities(bplsActivitiesArray);
          }

          if (key === 'signatory_1_name') {
            replacementValue = _.get(
              CMS_COMPONENTS,
              'BPLS_SIGNATORY_ONE_NAME',
              ''
            );
          }

          if (key === 'signatory_1_designation') {
            replacementValue = _.get(
              CMS_COMPONENTS,
              'BPLS_SIGNATORY_ONE_DESIGNATION',
              ''
            );
          }

          if (key === 'signatory_1_signature') {
            replacementValue = `<p><strong><span style="font-size: 10pt;"><img style="display: block; margin-left: auto; margin-right: auto;" src="${_.get(
              CMS_COMPONENTS,
              'BPLS_SIGNATORY_ONE_SIGNATURE',
              ''
            )}" alt="" width="111" height="111"></span></strong></p>`;
          }

          if (key === 'signatory_2_name') {
            replacementValue = _.get(
              CMS_COMPONENTS,
              'BPLS_SIGNATORY_TWO_NAME',
              ''
            );
          }

          if (key === 'signatory_2_designation') {
            replacementValue = _.get(
              CMS_COMPONENTS,
              'BPLS_SIGNATORY_TWO_DESIGNATION',
              ''
            );
          }

          if (key === 'signatory_2_signature') {
            replacementValue = `<p><strong><span style="font-size: 10pt;"><img style="display: block; margin-left: auto; margin-right: auto;" src="${_.get(
              CMS_COMPONENTS,
              'BPLS_SIGNATORY_TWO_SIGNATURE',
              ''
            )}" alt="" width="111" height="111"></span></strong></p>`;
          }

          if (key === 'signatory_3_name') {
            replacementValue = _.get(
              CMS_COMPONENTS,
              'BPLS_SIGNATORY_THREE_NAME',
              ''
            );
          }

          if (key === 'signatory_3_designation') {
            replacementValue = _.get(
              CMS_COMPONENTS,
              'BPLS_SIGNATORY_THREE_DESIGNATION',
              ''
            );
          }

          if (key === 'signatory_3_signature') {
            replacementValue = `<p><strong><span style="font-size: 10pt;"><img style="display: block; margin-left: auto; margin-right: auto;" src="${_.get(
              CMS_COMPONENTS,
              'BPLS_SIGNATORY_THREE_SIGNATURE',
              ''
            )}" alt="" width="111" height="111"></span></strong></p>`;
          }

          const sanitizedReplacementValue = DOMPurify.sanitize(
            String(replacementValue ?? '')
          );
          updatedHtml = updatedHtml.split(tag).join(sanitizedReplacementValue);
        }
      }

      return updatedHtml;
    };

    const paperStyle = DOMPurify.sanitize(generatePrintStyles());
    const sanitizedTemplate = DOMPurify.sanitize(htmlString);

    const updatedHtmlString = replacePlaceholders(sanitizedTemplate, values);
    const sanitizedOutput = DOMPurify.sanitize(paperStyle + updatedHtmlString);

    const printWindow = window.open();
    printWindow.document.open();
    printWindow.document.write(sanitizedOutput);
    printWindow.document.close();
    printWindow.focus();

    imagesLoaded(printWindow, () => {
      printWindow.print();
      printWindow.close();
    });
  };

  return (
    <>
      <div className="module-inner">
        <div className="d-flex align-items-center mb-2">
          <button
            type="button"
            className="btn btn-link text-dark p-0 mr-2"
            onClick={handleBack}
          >
            <i className="fas fa-arrow-left" />
          </button>
          <div className="module-inner-title mb-0">Official Receipts</div>
        </div>
        <div className="container-fluid">
          <div className="d-flex justify-content-center">
            {localStorage.getItem('permit_type') ==
              'Business Permit and License Application (BPLS)' && (
              <div className="p-4 border rounded mb-3">
                <h5 className="text-muted">
                  BIN:{' '}
                  <strong className="ml-1 text-primary">
                    {_.get(bplsPermitApplication, 'bin', 'N/A')}
                  </strong>
                </h5>
                <h5 className="text-muted">
                  Business Name:{' '}
                  <strong className="ml-1 text-primary">
                    {_.get(bplsPermitApplication, 'business_name', 'N/A')}
                  </strong>
                </h5>
                <h5 className="text-muted">
                  Module:{' '}
                  <strong className="ml-1 text-primary">
                    {_.get(item, 'attributes.module_type', 'N/A')}
                  </strong>
                </h5>
                <h5 className="text-muted mb-0">
                  Transaction Type:{' '}
                  <strong className="ml-1 text-primary">
                    {_.get(bplsPermitApplication, 'type', 'N/A')}
                  </strong>
                </h5>
              </div>
            )}
            {localStorage.getItem('permit_type') == 'Local Civil Registry' && (
              <div className="p-4 border rounded mb-3">
                <h5 className="text-muted">
                  Document Owner Name:{' '}
                  <strong className="ml-1 text-primary">
                    {_.get(item, 'attributes.name', 'N/A')}
                  </strong>
                </h5>
                <h5 className="text-muted">
                  Module:{' '}
                  <strong className="ml-1 text-primary">
                    {_.get(item, 'attributes.module_type', 'N/A')}
                  </strong>
                </h5>
                <h5 className="text-muted mb-0">
                  Transaction Type:{' '}
                  <strong className="ml-1 text-primary">
                    {_.get(item, 'attributes.transaction_type', 'N/A')}
                  </strong>
                </h5>
              </div>
            )}
          </div>

          <div
            className="row"
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            <button
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary font-weight-bold button-distribution-report"
              style={{ marginTop: '0px' }}
              type="button"
            >
              Create
            </button>
            <div className="" style={{ width: '100%' }}>
              {isLoading ? (
                <div
                  className="loading d-flex text-center justify-content-center align-items-center"
                  style={{ height: '500px' }}
                >
                  <div className="spinner text-center ">
                    <span className="fas fa-5x fa-spin fa-spinner" />
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    // padding: "10px",
                    marginBottom: '20px',
                  }}
                >
                  <div className="my-3">
                    {officialReceiptList.length > 0 ? (
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th scope="col" className="font-weight-semibold">
                                OR NUMBER
                              </th>
                              <th scope="col" className="font-weight-semibold">
                                DATE
                              </th>
                              <th
                                scope="col"
                                className="font-weight-semibold text-right"
                              >
                                AMOUNT
                              </th>
                              <th
                                scope="col"
                                className="font-weight-semibold text-right"
                              >
                                REMARKS
                              </th>
                              <th
                                scope="col"
                                className="font-weight-semibold text-right"
                              >
                                <span className="pr-3">ACTIONS</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {officialReceiptList.map((item, index) => (
                              <tr key={index}>
                                <td>{_.get(item, 'number') || '---'}</td>
                                <td>{_.get(item, 'date_human') || '---'}</td>
                                <td className="text-right">
                                  {_.get(item, 'amount') || '---'}
                                </td>
                                <td className="text-truncate">
                                  {_.get(item, 'remarks') || '---'}
                                </td>
                                <td className="text-right">
                                  <div className="d-flex justify-content-end">
                                    <button
                                      className="btn btn-icon btn-sm mr-2"
                                      onClick={handleViewOr(item)}
                                      title="Print preview"
                                    >
                                      <i className="fas fa-print text-primary"></i>
                                    </button>

                                    {_.get(item, 'is_finalized') === false && (
                                      <>
                                        <button
                                          className="btn btn-icon btn-sm mr-2"
                                          onClick={handleEdit(item)}
                                          title="Edit OR"
                                        >
                                          <i className="far fa-edit text-info"></i>
                                        </button>
                                        <button
                                          className="btn btn-icon btn-sm mr-2"
                                          onClick={handleFinalize(item)}
                                          title="Finalize"
                                        >
                                          <i className="fas fa-check text-success"></i>
                                        </button>
                                      </>
                                    )}

                                    <button
                                      className="btn btn-icon btn-sm mr-2"
                                      onClick={handleViewOrFees(item)}
                                      title="View Fees"
                                    >
                                      <i className="far fa-eye text-primary"></i>
                                    </button>
                                    <button
                                      className="btn btn-icon btn-sm"
                                      onClick={handleRemove(item)}
                                      title="Delete OR Draft"
                                    >
                                      <i className="far fa-trash-alt text-danger"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div className="row">
                          <div className="col-md-3" />

                          <div className="col-md-3 text-right">
                            <small className="text-muted w-100">
                              Total Amount:{' '}
                              <strong className="text-success ml-1">
                                ₱{totalAmount}
                              </strong>
                            </small>
                          </div>

                          <div className="col-md-3 text-right">
                            <small className="text-muted w-100">
                              Amount with OR:{' '}
                              <strong className="text-success ml-1">
                                ₱{amountWithOr}
                              </strong>
                            </small>
                          </div>

                          <div className="col-md-3 text-right">
                            <small className="text-muted w-100">
                              Amount without OR:{' '}
                              <strong className="text-danger ml-1">
                                ₱{amountWithoutOr}
                              </strong>
                            </small>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center justify-content-center h-100">
                        <div className="text-center mx-auto py-4">
                          <img
                            src={emptyStateImage}
                            className="img-responsive image-wrapper mb-4 mt-3"
                            alt="Empty State"
                          />
                          <p className="emp-title mb-0">No Item Found</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Log.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  finalizeOfficialReceipt: PropTypes.instanceOf(Function).isRequired,
  removeOfficialReceipt: PropTypes.instanceOf(Function).isRequired,
  getOfficialReceipts: PropTypes.instanceOf(Function).isRequired,
  officialReceiptList: PropTypes.instanceOf(Array).isRequired,
  transactionId: PropTypes.string.isRequired,
  getListCms: PropTypes.instanceOf(Function).isRequired,
  itemHtml: PropTypes.instanceOf(Object).isRequired,
  findPaymentById: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  officialReceiptList: _.get(api, `${c.GET_OFFICIAL_RECEIPTS}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_OFFICIAL_RECEIPTS) > -1,
  transactionId: _.get(match, 'params.transactionId') || '',
  itemHtml: (_.get(api, `${'CMS/get_settings'}.list`) || [])[0] || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default withStyles(styles)(enhance(Log));
